import React from "react"
import { isEmpty } from "lodash-es"
import { useBackfillReportableFieldContext } from "contexts/BackfillReportableFieldContext"
import FieldLabel from "shared/FieldLabel"
import { FormsyHiddenInput } from "shared/inputs"
import { Select } from "shared/selects"

const formOptions = (forms) => forms.map((form) => (
  {
    label: form.title,
    value: form.id,
  }
))

const BackfillReportableFieldFormForm = () => {
  const {
    selectedCategoryId,
    selectedCategoryForms,
    selectedFormId,
    selectForm,
  } = useBackfillReportableFieldContext()

  const noForms = isEmpty(selectedCategoryForms)
  const options = formOptions(selectedCategoryForms)
  const disabled = !selectedCategoryId

  return (
    <FieldLabel text="Form">
      <div className="flex flex-col gap-2">
        <Select
          backspaceDelete={false}
          disabled={disabled}
          onChange={selectForm}
          options={options}
          value={selectedFormId}
        />
        <FormsyHiddenInput
          name="formId"
          required
          value={selectedFormId}
        />
        {
          selectedCategoryId && noForms && (
            <p className="text-xs text-dark">
              The selected category has no forms.
            </p>
          )
        }
      </div>
    </FieldLabel>
  )
}

export default BackfillReportableFieldFormForm
